var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UserActionsWrap',{attrs:{"form-title":"Forgot<br> your password?"}},[_c('RecoveryForm')],1),_c('UserActionsNavigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }